import { useCallback, useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../store/hooks";
import {
  selectOrderOption,
  setOrderOption as setOrderOptionAction,
  resetOrderOption as resetOrderOptionAction,
  resetOrderTypeToDefault as resetOrderTypeToDefaultAction,
  setOrderOptionUtmSource,
} from "../store/orderOptionSlice";
import { OrderOptionModel } from "../models";
import { useStore } from "./useStore"; // your Redux-backed useStore

export function useOrderOption() {
  const dispatch = useAppDispatch();
  const orderOption = useAppSelector(selectOrderOption);
  const { utm } = useStore();

  // Ensure utm_source is filled from store.utm if empty
  useEffect(() => {
    if (utm && !orderOption.utm_source) {
      dispatch(setOrderOptionUtmSource(utm));
    }
  }, [dispatch, utm, orderOption.utm_source]);

  const setOrderOption = useCallback(
    (value: OrderOptionModel) => {
      dispatch(setOrderOptionAction(value));
    },
    [dispatch],
  );

  const resetOrderOption = useCallback(() => {
    dispatch(resetOrderOptionAction());
  }, [dispatch]);

  const resetOrderTypeToDefault = useCallback(() => {
    dispatch(resetOrderTypeToDefaultAction());
  }, [dispatch]);

  return {
    orderOption,
    setOrderOption,
    resetOrderOption,
    resetOrderTypeToDefault,
  };
}
